import { WebApiRequest, HTTP_POST } from "tools/webservice";
import { api } from "apis/caseEvent";

export const addSaveEvent = (controlNumber, successCallback, errorCallBack, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addSaveEvent(controlNumber),
  successCallback: successCallback,
  errorCallback: errorCallBack,
  mountedRef: mountedRef
});